export const payoutStatusLabels = {
  pending: "Pendiente",
  approved: "Aprobada",
  paid: "Pagada",
  rejected: "Rechazada",
};

export const payoutStatusClassNames = {
  pending: "bg-yellow-100 text-yellow-800",
  approved: "bg-blue-100 text-blue-800",
  paid: "bg-green-100 text-green-800",
  rejected: "bg-red-100 text-red-800",
};

// Reasons returned by POST /researches/payouts/ (Research.commission_payable_errors and
// validate_researches_payable in cytpanel), shown to the broker in Spanish
const payoutErrorMessages = {
  "research does not belong to you": "no pertenece a tu cuenta",
  "research is not completed": "la investigación no ha concluido",
  "research report PDF has not been generated": "el reporte PDF aún no está disponible",
  "research has not been paid": "la investigación no ha sido pagada",
  "research has no commission amount": "no tiene comisión asignada",
  "research commission is not pending": "su comisión ya fue procesada",
  "research is already in a payout request": "ya está incluida en otra solicitud de pago",
  "all researches in a payout must belong to the same membership":
    "Las investigaciones deben pertenecer a la misma cuenta para solicitarse juntas.",
  "payout amounts do not match the researches' commissions":
    "Los montos no coinciden con las comisiones. Recarga la página e intenta de nuevo.",
  "payout method must belong to the researches' membership":
    "La cuenta bancaria debe pertenecer a la misma cuenta que las investigaciones.",
};

const translate = (message) => payoutErrorMessages[message] || message;

/**
 * Human readable lines for a failed payout request, e.g.
 * ["Investigación 1a2b3c4d: la investigación no ha sido pagada"].
 */
export const payoutRequestErrorLines = (error) => {
  const details = error?.response?.data?.details;
  if (!Array.isArray(details)) return [];
  return details.map((detail) =>
    detail.research_id
      ? `Investigación ${detail.research_id.slice(0, 8)}: ${detail.errors.map(translate).join(", ")}`
      : translate(detail.error),
  );
};
